/**
 * The server's refusal of an offer's contingency elections (422
 * `offer_contingencies_invalid`), shown where the buyer or seller can fix it:
 *
 * - `ContingencyErrorBanner`: the refusal's `message`, plus any field error no
 *   rendered field can show;
 * - `ContingencyFieldError`: one field's message, next to its contingency.
 *
 * Deadline field errors (`<key>_days`) render inside ContingencyDeadlineField.
 * See `parseContingencyElectionError` in contingencyCatalog.js.
 */
import React from 'react';
import { unplacedFieldErrors } from './contingencyCatalog';
import styles from './ContingencyElectionErrors.module.css';

/**
 * @param {object} props
 * @param {{message: string, fieldErrors: object}|null} props.error
 * @param {Array<Object>} props.options - Catalog entries as rendered.
 * @param {string[]} [props.extraKeys] - Other keys with a rendered field
 *   (`['lead_paint']` when the lead-paint election is shown).
 */
export function ContingencyErrorBanner({ error, options = [], extraKeys = [] }) {
  if (!error) return null;
  const unplaced = unplacedFieldErrors(error.fieldErrors, options, extraKeys);
  return (
    <div className={styles.banner} role="alert" data-testid="contingency-error-banner">
      <p className={styles.message}>{error.message}</p>
      {unplaced.length > 0 && (
        <ul className={styles.list}>
          {unplaced.map((msg) => (
            <li key={msg}>{msg}</li>
          ))}
        </ul>
      )}
    </div>
  );
}

export function ContingencyFieldError({ field, message }) {
  if (!message) return null;
  return (
    <p className={styles.fieldError} role="alert" data-testid={`contingency-error-${field}`}>
      {message}
    </p>
  );
}
